import { useMixpanel } from 'react-mixpanel-browser';
import { reportBusinessActionToMixpanel } from '../../../utils/reportBusinessActionToMixpanel';
import { AnalyticsToggler } from './AnalyticsToggler';
import { AnalyticsOrderType } from '../../../constants/analytics';

export function AnalyticsOrderTypeFilter({ selected, onChange }) {
  const mixpanel = useMixpanel();
  const orderTypeOptions = [
    { value: AnalyticsOrderType.SALES, label: 'Sales' },
    { value: AnalyticsOrderType.ORDERS, label: 'Orders' },
    { value: AnalyticsOrderType.UNITS, label: 'Units' },
  ];

  const onToggle = (value) => {
    reportBusinessActionToMixpanel(mixpanel, 'sales-dashboard-order-type', { orderType: value });
    onChange(value);
  };

  return (
    <div>
      <AnalyticsToggler selected={selected} options={orderTypeOptions} onChange={onToggle} />
    </div>
  );
}
